// Generated by purs version 0.15.15
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
var optionIsNone = /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
    return true;
})(function (v) {
    return false;
});
var selectPhase = function (input) {
    var $11 = !input.portalEnabled;
    if ($11) {
        return "featureUnavailable";
    };
    var $12 = optionIsNone(input.routeListingId);
    if ($12) {
        return "noListingSelected";
    };
    var $13 = !input.canReadWorkspace;
    if ($13) {
        return "readDenied";
    };
    if (input.unsafeFactPromotionAttempted) {
        return "unsafeFactPromotionRefused";
    };
    if (input.decisionSubmitting) {
        return "submittingDecision";
    };
    if (input.decisionSubmitFailed) {
        return "submitFailed";
    };
    if (input.decisionAcceptedRefreshing) {
        return "submittedRefreshing";
    };
    if (input.summaryUpdated) {
        return "summaryUpdated";
    };
    if (input.workspaceLoadFailed) {
        return "loadFailed";
    };
    var $20 = input.workspaceLoaded && !input.canWriteDecision;
    if ($20) {
        return "writeDeniedReadOnly";
    };
    if (input.workspaceLoaded) {
        return "loadedWorkspace";
    };
    return "loading";
};
var listingLabel = /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
    return "No listing selected";
})(function (v) {
    return v;
});
var buildWorkspaceLoadTrigger = function (input) {
    var $23 = input.portalEnabled && (input.canReadWorkspace && (!input.workspaceLoaded && !input.workspaceLoadFailed));
    if ($23) {
        return Ouroboros_Services_Clients_Interop_Option.map(function (listingId) {
            return {
                listingId: listingId
            };
        })(input.routeListingId);
    };
    return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
};
var buildDecisionSubmitTrigger = function (input) {
    return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
        return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
    })(function (listingId) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        })(function (claimId) {
            return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
            })(function (targetDisposition) {
                return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
                    return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
                })(function (reviewer) {
                    return Ouroboros_Services_Clients_Interop_Option.map(function (reason) {
                        return {
                            listingId: listingId,
                            claimId: claimId,
                            targetDisposition: targetDisposition,
                            reviewer: reviewer,
                            reason: reason
                        };
                    })(input.draftReason);
                })(input.draftReviewer);
            })(input.draftTargetDisposition);
        })(input.draftClaimId);
    })(input.routeListingId);
};
var buildListingInferenceReviewPortalViewProps = function (input) {
    var workspaceLoadTrigger = buildWorkspaceLoadTrigger(input);
    var phase = selectPhase(input);
    var canSubmitDecision = input.canReadWorkspace && (input.canWriteDecision && (input.workspaceLoaded && (!input.decisionSubmitting && !input.unsafeFactPromotionAttempted)));
    var decisionSubmitTrigger = (function () {
        if (canSubmitDecision) {
            return buildDecisionSubmitTrigger(input);
        };
        return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
    })();
    return {
        routeListingId: input.routeListingId,
        listingLabel: listingLabel(input.routeListingId),
        phase: phase,
        canReadWorkspace: input.canReadWorkspace,
        canWriteDecision: input.canWriteDecision,
        canSubmitDecision: canSubmitDecision,
        decisionSubmissionReadOnly: input.canReadWorkspace && !input.canWriteDecision,
        unsafeFactPromotionRefused: phase === "unsafeFactPromotionRefused",
        workspaceLoadTrigger: workspaceLoadTrigger,
        decisionSubmitTrigger: decisionSubmitTrigger
    };
};
export {
    buildListingInferenceReviewPortalViewProps
};
//# sourceMappingURL=index.js.map
